import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, mergeMap, switchMap } from 'rxjs/operators';

import { RolesService } from '../../../../../../../ongoing/src/lib/services/roles/roles.service';

import * as rolesActions from '../actions/roles.actions';

@Injectable()
export class RolesEffects {
  constructor(private actions$: Actions, private rolesService: RolesService) {}

  LoadRoles$ = createEffect(() =>
    this.actions$.pipe(
      ofType(rolesActions.loadRoles),
      mergeMap(() => {
        return this.rolesService.read().pipe(
          map(
            role => rolesActions.loadRolesSuccess({ payload: role.result }),
            catchError(err => of(rolesActions.loadRolesFail({ payload: err })))
          )
        );
      })
    )
  );

  loadMoreRoles$ = createEffect(() =>
    this.actions$.pipe(
      ofType(rolesActions.loadMoreRoles),
      mergeMap(res => {
        return this.rolesService.loadMore(res.payload.skip, res.payload.limit).pipe(
          map(role => rolesActions.loadMoreRolesSuccess({ payload: role.result })),
          catchError(err => of(rolesActions.loadMoreRolesFail({ payload: err })))
        );
      })
    )
  );

  loadAllRoles$ = createEffect(() =>
    this.actions$.pipe(
      ofType(rolesActions.loadAllRoles),
      mergeMap(() => {
        return this.rolesService.loadAll().pipe(
          map(role => rolesActions.loadAllRolesSuccess({ payload: role.result.results })),
          catchError(err => of(rolesActions.loadAllRolesFail(err)))
        );
      })
    )
  );

  searchRoles$ = createEffect(() =>
    this.actions$.pipe(
      ofType(rolesActions.searchRoles),
      switchMap(res => {
        return this.rolesService.search(res.payload).pipe(
          distinctUntilChanged(),
          debounceTime(500),
          map(role => rolesActions.searchRolesSuccess({ payload: role.result.results })),
          catchError(err => of(rolesActions.searchRolesFail({ payload: err })))
        );
      })
    )
  );
}
